import React from 'react';
import EditableText from '../../editor/EditableText';

export const Method = (filter, row) => {
  const str = row[filter.id] ? row[filter.id].toLowerCase() : '';
  return str.includes(filter.value.toLowerCase());
};

export const Filter = ({ filter, onChange }) => (
  <EditableText hideIcon={true} noLang={true} finishEdit={onChange} />
);